import React, { Component } from 'react';
import { connect } from "react-redux";
import { compose } from "redux";
import { change } from 'redux-form';

import { TAB_OCCUPATIONS, TAB_ROOMS } from "../constants";
import { setArrival } from "../store/actions";
import { SANDAMIANO_HOTEL_ID } from '../utils';

import DepartureArrival from './DepartureArrival';
import Occupancies from "./Occupancies";
import Rooms from './Rooms';
import RoomsSandamiano from './Rooms/RoomsSandamiano';

class Step1 extends Component {
	availabilitiesFromDate = null;

	constructor(props) {
		super(props);

		this.state = {
			tab: TAB_ROOMS,
		};
	}

	onTabChange = (tab) => {
		this.setState({ tab: tab });
	};

	handleRoomTypeAvailabilityClick = (roomType, date) => {
		// změníme datum příjezdu
		this.props.dispatch(setArrival(date, (store) => {
			// a přednastavíme vybraný typ pokoje
			const roomOffer = store.app.roomOffers.find(roomOffer => roomOffer.id === parseInt(roomType, 10));
			if (roomOffer && store.app.noOfNights >= roomOffer.minNights) {
				const room = {...roomOffer, guestTypes: {}};
				Object.values(store.app.guestTypes).forEach(guestType => room.guestTypes[guestType.id] = guestType.default ? 1 : 0);
				this.props.dispatch(change('bookingForm', 'rooms[' + roomType + '][0]', room));
			}

			this.setState({ tab: TAB_ROOMS });
		}));
	};

	render() {
		const { isEventPackageOfferVisible } = this.props;

		return (
            <div className="container">

				<DepartureArrival onTabChange={this.onTabChange} tab={this.state.tab} />

				{isEventPackageOfferVisible &&
				<RoomsSandamiano/>
				}

				{!isEventPackageOfferVisible && this.state.tab === TAB_OCCUPATIONS &&
				<Occupancies
					fromDate={this.availabilitiesFromDate}
					onFromDateChange={date => this.availabilitiesFromDate = date}
					onRoomTypeAvailabilityClick={(roomType, date) => this.handleRoomTypeAvailabilityClick(roomType, date)}
				/>
				}

				{!isEventPackageOfferVisible && this.state.tab === TAB_ROOMS &&
				<Rooms/>
				}

            </div>
		);
	}
}

export default compose(
	connect((state) => ({
		isEventPackageOfferVisible: !!state.app.package && state.app.hotelId === SANDAMIANO_HOTEL_ID,
	})),
)(Step1);



// WEBPACK FOOTER //
// ./src/components/Step1.jsx